<template>
    <div
        class="ds-toast-message flex items-center gap-2"
        :class="`ds-toast-${message.severity}`"
    >
        <DsIcon
            :icon="`fa-solid fa-${message.severity === 'error' ? 'triangle-exclamation' : 'circle-check'}`"
            size="md"
        />

        <div class="align-items-start mr-3 max-w-md flex-1">
            <div class="text-content-md font-normal">{{ message.detail }}</div>
        </div>

        <DsIconButton
            :aria-label="!showCloseTooltip && 'Close'"
            icon="fa-solid fa-xmark"
            onDarkBg
            size="sm"
            :tooltipText="showCloseTooltip ? 'Close' : ''"
            tooltipPosition="top"
            @click="close"
        />
    </div>
</template>

<script setup lang="ts">
import DsIcon from '@/components/design-system/DsIcon.vue';
import DsIconButton from '@/components/design-system/button/DsIconButton.vue';
import type { ToastMessageOptions } from 'primevue/toast';
import { nextTick, ref } from 'vue';

defineProps<{
    message: ToastMessageOptions;
}>();

const emit = defineEmits<{
    (e: 'close'): void;
}>();

/** DsIconButton's popover glitches during toast slide-out animation.
 * Conditioning the tooltip and delaying the animation firing avoids the glitch.
 */
const showCloseTooltip = ref(true);
function close() {
    showCloseTooltip.value = false;
    nextTick(() => {
        emit('close');
    });
}
</script>

<style scoped lang="scss">
.ds-toast-message {
    @apply rounded-lg py-2 pl-4 pr-3 shadow-toast xs:w-[calc(100%-48px)] md:w-fit;
}
.ds-toast-error {
    @apply bg-ds-red-600 text-content-inverse;
}
.ds-toast-info {
    @apply bg-ds-gray-800 text-content-inverse;
}
</style>
